import React from "react";
import { Provider } from "react-redux";
import { Store } from "redux";
import { ToastContainer } from "react-toastify";

import AuthComponent from "./auth/auth.component";

import { ApplicationStore, createApplicationStore } from "~/app/application.store";
import { RoutesComponent } from "~/view/routes.component";
import "~/view/assets/styles/app.scss";

export const App: React.FC = () => {
  const store: Store<ApplicationStore> = createApplicationStore();

  return (
    <Provider store={store}>
      {/* <GlobalError> */}
      <AuthComponent>
        <RoutesComponent />
      </AuthComponent>
      {/* </GlobalError> */}
      <ToastContainer
        position="top-right"
        pauseOnFocusLoss={false}
        toastStyle={{ fontSize: "1.4rem", color: "#010101" }}
      />
    </Provider>
  );
};
